var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "yxtbiz-dimension" },
    [
      _c("p", { staticClass: "dimtitle mb16", on: { click: _vm.addGroup } }, [
        _vm._v(
          "\n    " +
            _vm._s(
              _vm.isSingle
                ? "+ " + _vm.$t("pc_spmodel_biz_10")
                : "+ " + _vm.$t("pc_spmodel_biz_11")
            ) +
            "\n  "
        ),
      ]),
      _c(
        "dimline",
        {
          ref: "dimline",
          attrs: {
            anded: _vm.ruleConfig.logic,
            isGray: false,
            isShow:
              _vm.ruleConfig.conditions && _vm.ruleConfig.conditions.length > 1,
          },
          on: {
            "update:anded": function ($event) {
              return _vm.$set(_vm.ruleConfig, "logic", $event)
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "dimension-content dimension-c" },
            _vm._l(_vm.ruleConfig.conditions, function (item, index) {
              return _c(
                "div",
                {
                  key: index,
                  staticClass: "bgray pl16 pt16",
                  class: {
                    pl8: item.rules.length === 1,
                  },
                },
                [
                  _c(
                    "dimline",
                    {
                      ref: "dimline1" + index,
                      refInFor: true,
                      attrs: {
                        num: index,
                        anded: item.logic,
                        isShow: item.rules.length > 1,
                        isGray: true,
                      },
                      on: {
                        "update:anded": function ($event) {
                          return _vm.$set(item, "logic", $event)
                        },
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "dimension-c" },
                        _vm._l(item.rules, function (value, i) {
                          return _c(
                            "div",
                            {
                              key: i,
                              class: {
                                mb20:
                                  i + 1 < item.rules.length &&
                                  !value.description,
                                mb16:
                                  i + 1 < item.rules.length &&
                                  value.description,
                              },
                            },
                            [
                              value.type !== 3 && !_vm.isDataModel
                                ? _c(
                                    "yxt-select",
                                    {
                                      staticClass: "w74 mr12",
                                      attrs: {
                                        filterable: "",
                                        placeholder: _vm.$t(
                                          "pc_spmodel_biz_select"
                                        ),
                                        size: "small",
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.typeChangeFn(index, i)
                                        },
                                      },
                                      model: {
                                        value: value.type,
                                        callback: function ($$v) {
                                          _vm.$set(value, "type", $$v)
                                        },
                                        expression: "value.type",
                                      },
                                    },
                                    _vm._l(_vm.type, function (option) {
                                      return _c("yxt-option", {
                                        key: option.id,
                                        attrs: {
                                          label: option.label,
                                          value: option.id,
                                        },
                                      })
                                    }),
                                    1
                                  )
                                : _vm._e(),
                              value.type === 1
                                ? [
                                    _c("target-rule", {
                                      ref: "targetrule-" + index + "-" + i,
                                      refInFor: true,
                                      attrs: {
                                        uselocalStorage: true,
                                        type1: _vm.type1,
                                        value:
                                          _vm.ruleConfig.conditions[index]
                                            .rules[i],
                                      },
                                      on: {
                                        "update:value": function ($event) {
                                          return _vm.$set(
                                            _vm.ruleConfig.conditions[index]
                                              .rules,
                                            i,
                                            $event
                                          )
                                        },
                                      },
                                    }),
                                  ]
                                : _vm._e(),
                              value.type === 2
                                ? [
                                    _c("label-rule", {
                                      ref: "labelrule-" + index + "-" + i,
                                      refInFor: true,
                                      attrs: {
                                        uselocalStorage: true,
                                        type2: _vm.type2,
                                        value:
                                          _vm.ruleConfig.conditions[index]
                                            .rules[i],
                                      },
                                      on: {
                                        "update:value": function ($event) {
                                          return _vm.$set(
                                            _vm.ruleConfig.conditions[index]
                                              .rules,
                                            i,
                                            $event
                                          )
                                        },
                                      },
                                    }),
                                  ]
                                : _vm._e(),
                              value.type === 3
                                ? [
                                    _c("target-rule", {
                                      ref: "targetrule-" + index + "-" + i,
                                      refInFor: true,
                                      attrs: {
                                        isDataModel: _vm.isDataModel,
                                        uselocalStorage: true,
                                        type1: _vm.type3,
                                        value:
                                          _vm.ruleConfig.conditions[index]
                                            .rules[i],
                                      },
                                      on: {
                                        "update:value": function ($event) {
                                          return _vm.$set(
                                            _vm.ruleConfig.conditions[index]
                                              .rules,
                                            i,
                                            $event
                                          )
                                        },
                                      },
                                    }),
                                  ]
                                : _vm._e(),
                              _c("yxt-svg", {
                                staticClass:
                                  "hand color-gray-9 p2 hover-bg-gray-3",
                                staticStyle: {
                                  "vertical-align": "middle",
                                  "margin-left": "-4px",
                                },
                                attrs: {
                                  width: "20px",
                                  height: "20px",
                                  "icon-class": "delete",
                                },
                                nativeOn: {
                                  click: function ($event) {
                                    return _vm.delFn(index, i)
                                  },
                                },
                              }),
                              !_vm.isDataModel &&
                              Number(
                                _vm.ruleConfig.conditions[index].rules[i].state
                              ) > 0 &&
                              Number(
                                _vm.ruleConfig.conditions[index].rules[i].state
                              ) < 5
                                ? _c("unusual", {
                                    attrs: {
                                      content:
                                        value.type === 1
                                          ? _vm.targetcontent[
                                              _vm.ruleConfig.conditions[index]
                                                .rules[i].state
                                            ]
                                          : _vm.labelcontent[
                                              _vm.ruleConfig.conditions[index]
                                                .rules[i].state
                                            ],
                                    },
                                  })
                                : _vm._e(),
                              _vm.isDataModel &&
                              Number(
                                _vm.ruleConfig.conditions[index].rules[i].state
                              ) > 0 &&
                              Number(
                                _vm.ruleConfig.conditions[index].rules[i].state
                              ) < 5
                                ? _c("unusual", {
                                    attrs: {
                                      content: _vm.$t("pc_spmodel_data_unuse"),
                                    },
                                  })
                                : _vm._e(),
                              value.description
                                ? _c(
                                    "yxt-tooltip",
                                    {
                                      attrs: {
                                        content: value.description,
                                        placement: "left",
                                        "open-filter": "",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "ellipsis mt8",
                                          staticStyle: {
                                            "line-height": "14px",
                                            color: "#595959",
                                            "font-size": "12px",
                                            "margin-top": "6px",
                                            "max-width": "200px",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(value.description) +
                                              "\n                "
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            2
                          )
                        }),
                        0
                      ),
                    ]
                  ),
                  !_vm.isSingle
                    ? _c(
                        "div",
                        {
                          staticClass: "dimtitle mt12 dimtitle1",
                          class: {
                            ml32: item.rules.length !== 1,
                            mb16:
                              _vm.ruleConfig.conditions.length !== index + 1,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.addItem(index)
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n          + " +
                              _vm._s(_vm.$t("pc_spmodel_biz_10")) +
                              "\n        "
                          ),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              )
            }),
            0
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }